import { useCallback, useEffect, useRef, useState } from 'react';
import type { UIMessage, UUID } from '@dopomogai/types';
import type { InitTestChatResponse } from '@dopomogai/types';
import { AgentKitError } from '../../types';

export interface ConversationUsage {
  cost: number;
  tokensInput: number;
  tokensOutput: number;
}

export function useConversationState(
  sessionRef: React.MutableRefObject<InitTestChatResponse | null>
) {
  const [messages, setMessages] = useState<UIMessage[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSynthesizing, setIsSynthesizing] = useState(false);
  const [error, setError] = useState<AgentKitError | null>(null);
  const [streamConversationId, setStreamConversationId] = useState<UUID | null>(null);
  const [usage, setUsage] = useState<ConversationUsage>({ cost: 0, tokensInput: 0, tokensOutput: 0 });

  const streamControllerRef = useRef<{ close: () => void } | null>(null);
  const assistantMessageIdRef = useRef<string | null>(null);
  const streamingContentRef = useRef<string>('');

  useEffect(() => {
    return () => {
      streamControllerRef.current?.close();
    };
  }, []);

  const clear = useCallback(() => {
    streamControllerRef.current?.close();
    setMessages([]);
    setError(null);
    setIsLoading(false);
    setIsSynthesizing(false);
    setStreamConversationId(null);
    sessionRef.current = null;
    assistantMessageIdRef.current = null;
    streamingContentRef.current = '';
    setUsage({ cost: 0, tokensInput: 0, tokensOutput: 0 });
  }, [sessionRef]);

  return {
    // state
    messages,
    setMessages,
    isLoading,
    setIsLoading,
    isSynthesizing,
    setIsSynthesizing,
    error,
    setError,
    usage,
    setUsage,
    streamConversationId,
    setStreamConversationId,
    // refs
    streamControllerRef,
    assistantMessageIdRef,
    streamingContentRef,
    // helpers
    clear,
  };
}


